import Constant from "../constants";
import Cookies from "js-cookie";
import * as utils from "resources/utils";

const METHOD_GET = "get";
const METHOD_POST = "post";
const METHOD_PUT = "put";
const METHOD_DELETE = "delete";
const METHOD_PATCH = "patch";

async function requestAPI(
  method: string,
  uri: string,
  body?: object,
  serviceBaseUrl?: string,
  noNeedAccessToken?: boolean,
) {

  // Build API header
  let headers: any = {
    Accept: "*/*",
    "Access-Control-Allow-Origin": "*",
  };
  if (body instanceof FormData) {
    headers = {}
  } else {
    headers["Content-Type"] = "application/json";
  }

  // Build API url
  let apiUrl = "";
  if (serviceBaseUrl) {
    apiUrl = serviceBaseUrl + uri;
  } else {
    apiUrl = Constant.apiBaseUrl + uri;
  }

  // Build API body
  let content_body = null;
  if (
    method.toLowerCase() === METHOD_POST ||
    method.toLowerCase() === METHOD_PUT ||
    method.toLowerCase() === METHOD_DELETE ||
    method.toLowerCase() === METHOD_PATCH
  ) {
    if (body) {
      if (body instanceof FormData) {
        console.log(body.get('user_file'))
        content_body = body;
      } else {
        content_body = JSON.stringify(body);
      }
    }
  }

  // Add jwt token to header
  const access_token = Cookies.get('access_token');
  headers['Authorization'] = `Bearer ${access_token}`
  headers['X-CSRF-TOKEN'] = Cookies.get('csrf_access_token');

  // Construct fetch options
  let fetchOptions: RequestInit = {
    "method": method,
    "headers": headers,
    "body": content_body,
  };

  // Run the fetching
  return fetch(apiUrl, fetchOptions)
  .then(res => {
    return res.json()
  })
  .then(data => {
    if (data?.msg === "Token has expired") {
      Cookies.remove("access_token");
      Cookies.remove("csrf_access_token");
      Cookies.remove("company_id");
      Cookies.remove("user");
      alert("Session has been expired! Please log in again.")
      if (!window.location.href.includes('/login')) {
        window.location.href = '/login';
      }
      window.location.reload();
    } else {
      if (data?.new_access_token) {
        utils.default.setCookies("access_token", data.new_access_token);
        utils.default.setCookies("csrf_access_token", data.new_csrf_access_token);
      }
      return data
    }
  })
  .catch(err => {
    return {
      "message": err
    }
  });
}

const ApiCaller = {
  get(url: string, baseUrl?: string): Promise<any> {
    return requestAPI(METHOD_GET, url, undefined, baseUrl);
  },

  post(url: string, data?: any, baseUrl?: string, noNeedAccessToken?: boolean): Promise<any> {
    return requestAPI(METHOD_POST, url, data, baseUrl, noNeedAccessToken);
  },

  patch(url: string, data?: any, baseUrl?: string): Promise<any> {
    return requestAPI(METHOD_PATCH, url, data, baseUrl);
  },

  put(url: string, data?: any, baseUrl?: string): Promise<any> {
    return requestAPI(METHOD_PUT, url, data, baseUrl);
  },

  delete(url: string, data?: any, baseUrl?: string): Promise<any> {
    return requestAPI(METHOD_DELETE, url, data, baseUrl);
  },
};

export default ApiCaller;
